import { render } from "./App.vue?vue&type=template&id=70d0a2db"
const script = {}

import "./App.vue?vue&type=style&index=0&id=70d0a2db&lang=css"
script.render = render

export default script